import { CALL_API } from '../middleware/ApiMiddleware';

export const FETCH_DEPARTMENT_LIST_REQUEST = 'FETCH_DEPARTMENT_LIST_REQUEST';
export const FETCH_DEPARTMENT_LIST_SUCCESS = 'FETCH_DEPARTMENT_LIST_SUCCESS';
export const FETCH_DEPARTMENT_LIST_FAILURE = 'FETCH_DEPARTMENT_LIST_FAILURE';

export const CREATE_DEPARTMENT_REQUEST = 'CREATE_DEPARTMENT_REQUEST';
export const CREATE_DEPARTMENT_SUCCESS = 'CREATE_DEPARTMENT_SUCCESS';
export const CREATE_DEPARTMENT_FAILURE = 'CREATE_DEPARTMENT_FAILURE';

export const EDIT_DEPARTMENT_SEQUENCE_REQUEST = 'EDIT_DEPARTMENT_SEQUENCE_REQUEST';
export const EDIT_DEPARTMENT_SEQUENCE_SUCCESS = 'EDIT_DEPARTMENT_SEQUENCE_SUCCESS';
export const EDIT_DEPARTMENT_SEQUENCE_FAILURE = 'EDIT_DEPARTMENT_SEQUENCE_FAILURE';

export const FETCH_DEPARTMENT_REQUEST = 'FETCH_DEPARTMENT_REQUEST';
export const FETCH_DEPARTMENT_SUCCESS = 'FETCH_DEPARTMENT_SUCCESS';
export const FETCH_DEPARTMENT_FAILURE = 'FETCH_DEPARTMENT_FAILURE';

export const EDIT_DEPARTMENT_REQUEST = 'EDIT_DEPARTMENT_REQUEST';
export const EDIT_DEPARTMENT_SUCCESS = 'EDIT_DEPARTMENT_SUCCESS';
export const EDIT_DEPARTMENT_FAILURE = 'EDIT_DEPARTMENT_FAILURE';

const baseURL = 'agencies/config/departments';

export const createDepartment = (departmentRequest: IDepartmentRequest) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'post',
    body: departmentRequest,
    authenticated: true,
    types: [CREATE_DEPARTMENT_REQUEST, CREATE_DEPARTMENT_SUCCESS, CREATE_DEPARTMENT_FAILURE],
  },
});

export const fetchDepartmentList = (hideLoadingWidget = false) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    authenticated: true,
    types: [FETCH_DEPARTMENT_LIST_REQUEST, FETCH_DEPARTMENT_LIST_SUCCESS, FETCH_DEPARTMENT_LIST_FAILURE],
    hideLoadingWidget,
  },
});

export const editDepartmentSequence = (sequence: number[]) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/sequence`,
    method: 'put',
    authenticated: true,
    body: { sequence },
    types: [EDIT_DEPARTMENT_SEQUENCE_REQUEST, EDIT_DEPARTMENT_SEQUENCE_SUCCESS, EDIT_DEPARTMENT_SEQUENCE_FAILURE],
  },
});

export const fetchDepartmentById = (departmentId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${departmentId}`,
    method: 'get',
    authenticated: true,
    types: [FETCH_DEPARTMENT_REQUEST, FETCH_DEPARTMENT_SUCCESS, FETCH_DEPARTMENT_FAILURE],
  },
});

export const editDepartment = (departmentId: number, departmentData: IDepartmentRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${departmentId}`,
    method: 'put',
    authenticated: true,
    body: departmentData,
    types: [EDIT_DEPARTMENT_REQUEST, EDIT_DEPARTMENT_SUCCESS, EDIT_DEPARTMENT_FAILURE],
  },
});
